// for generic error handling
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

// for sandwich bar on small screens
export const CLOSE_SIDEDRAWER = 'CLOSE_SIDEDRAWER';
export const TOGGLE_SIDEDRAWER = 'TOGGLE_SIDEDRAWER';
